import React from "react";

import { Input } from "src/common/components/Input";

type FormattedInputProps = Omit<React.ComponentProps<typeof Input>, "type">;

interface FormattedInputState {
	rawValue: string | undefined;
	formattedValue: string | undefined;
}

export function createFormattedInput(
	formatValue: (value: string | undefined) => string | undefined
): React.ComponentType<FormattedInputProps> {
	return class FormattedInput extends React.PureComponent<
		FormattedInputProps,
		FormattedInputState
	> {
		constructor(props: FormattedInputProps) {
			super(props);
			this.state = {
				rawValue: this.props.value,
				formattedValue: formatValue(this.props.value)
			};
		}

		componentDidUpdate(prevProps: FormattedInputProps): void {
			if (
				this.props.value !== prevProps.value &&
				this.props.value !== this.state.formattedValue
			) {
				this.setState({
					rawValue: this.props.value,
					formattedValue: formatValue(this.props.value)
				});
			}
		}

		render(): React.ReactNode {
			return (
				<Input
					{...this.props}
					value={this.state.rawValue}
					onChangeValue={this.onChangeValue}
				/>
			);
		}

		private onChangeValue = (rawValue: string): void => {
			const formattedValue = formatValue(rawValue);
			this.setState({ rawValue, formattedValue });
			if (this.props.onChangeValue) {
				this.props.onChangeValue(formattedValue);
			}
		};
	};
}
